import { useState } from "react";
import { useDispatch } from "react-redux";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";
import {
    SovosBox,
    SovosButton,
    SovosDialog,
    SovosDialogActions,
    SovosDialogContent,
    SovosDialogTitle,
    SovosMenuItem,
    SovosTextField,
    SovosToolbar,
    SovosToolbarActions,
    SovosToolbarMoreMenu,
    SovosTypography,
} from "mosaic-react";
import { OpenInNew, PlayArrow } from "mosaic-react-icons";
import { getImportProfileMappingByProfileAction, runCustomTemplateMappingAction } from "../../../store/actions/userActions";

export default function Goto(props) {
    const { i18n, history, params, pushNotification } = useGlobalValue();
    const dispatch = useDispatch();
    const { value: cell } = props || {};
    const { id, entity, mapping_id, has_mapping } = cell || {};

    const [fiscalYearDialogOpen, setFiscalYearDialogOpen] = useState(false);
    const [runFiscalYear, setRunFiscalYear] = useState("");

    const isValidFiscalYear = /^\d{4}$/.test(runFiscalYear);

    const handleOpen = () => {
        const locale = params?.locale || "en";
        const projectId = params?.projectId;
        const fiscalYear = params?.fiscalYear;
        const path = `/${locale}/${projectId}/${fiscalYear}/${id}/column_mapping/${entity || ""}`;
        history.push(path);
    };

    const notify = (message, type = "error") => {
        if (pushNotification) {
            pushNotification({ open: true, message, type, timeout: "short" });
        }
    };

    const handleRunConfirm = async () => {
        console.log("[Goto] handleRunConfirm called", { id, mapping_id, params, runFiscalYear });
        setFiscalYearDialogOpen(false);
        try {
            const profileId = parseInt(id, 10);
            let resolvedMappingId = parseInt(mapping_id, 10);
            if (!resolvedMappingId) {
                const mapping = await dispatch(getImportProfileMappingByProfileAction(profileId));
                resolvedMappingId = mapping?.id;
            }
            if (!resolvedMappingId) {
                notify(i18n`No mapping found for this profile`);
                setRunFiscalYear("");
                return;
            }
            const result = await dispatch(
                runCustomTemplateMappingAction({
                    profileId,
                    mappingId: resolvedMappingId,
                    projectId: params?.projectId,
                    fiscalYear: runFiscalYear,
                    importId: parseInt(params?.importId, 10) || null,
                }),
            );
            notify(
                result?.success ? i18n`Mapping run started successfully` : i18n`${result?.message || "Failed to run mapping"}`,
                result?.success ? "success" : "error",
            );
        } catch (e) {
            console.error("[Goto] handleRunConfirm error:", e);
            notify(i18n`Unexpected error running mapping`);
        }
        setRunFiscalYear("");
    };

    return (
        <SovosBox onClick={(e) => e?.stopPropagation()}>
            <SovosToolbar sx={{ backgroundColor: "transparent !important" }}>
                <SovosToolbarActions>
                    <SovosToolbarMoreMenu>
                        <SovosMenuItem onClick={handleOpen}>
                            <OpenInNew />
                            <SovosTypography children={i18n`Edit Mapping`} variant={"span"} />
                        </SovosMenuItem>
                        {has_mapping && (
                            <SovosMenuItem onClick={(e) => { e?.stopPropagation(); setFiscalYearDialogOpen(true); }}>
                                <PlayArrow />
                                <SovosTypography children={i18n`Run Mapping`} variant={"span"} />
                            </SovosMenuItem>
                        )}
                    </SovosToolbarMoreMenu>
                </SovosToolbarActions>
            </SovosToolbar>

            <SovosDialog
                open={fiscalYearDialogOpen}
                onClose={() => { setFiscalYearDialogOpen(false); setRunFiscalYear(""); }}
                maxWidth="xs"
                fullWidth
            >
                <SovosDialogTitle>{i18n`Run Mapping`}</SovosDialogTitle>
                <SovosDialogContent>
                    <SovosTextField
                        label={i18n`Fiscal Year`}
                        value={runFiscalYear}
                        onChange={(e) => {
                            const val = e.target.value.replace(/\D/g, "").slice(0, 4);
                            setRunFiscalYear(val);
                        }}
                        onKeyDown={(e) => { e.stopPropagation(); if (e.key === "Enter" && isValidFiscalYear) handleRunConfirm(); }}
                        inputProps={{ maxLength: 4 }}
                        placeholder="e.g. 2024"
                        fullWidth
                        autoFocus
                    />
                </SovosDialogContent>
                <SovosDialogActions>
                    <SovosButton variant="text" onClick={() => { setFiscalYearDialogOpen(false); setRunFiscalYear(""); }}>
                        {i18n`Cancel`}
                    </SovosButton>
                    <SovosButton
                        variant="contained"
                        onClick={(e) => { e?.stopPropagation(); handleRunConfirm(); }}
                        disabled={!isValidFiscalYear}
                    >
                        {i18n`Run`}
                    </SovosButton>
                </SovosDialogActions>
            </SovosDialog>
        </SovosBox>
    );
}
